module.exports = __webpack_public_path__ + "static/flags/SX-f8083c4b189b4766cb8fd54673e3fb17.gif";